// 医生工作室
const studio = r => require.ensure([], () => r(require('./')), 'studio')
// 医生工作室列表
const studioList = r => require.ensure([], () => r(require('./studio/list')), 'studioList')
// 医生工作室详情
const studioDetail = r => require.ensure([], () => r(require('./studio/detail')), 'studioDetail')
// 医生主页
const doctorHome = r => require.ensure([], () => r(require('./doctor-home')), 'doctorHome')
// 特色服务详情页
const specialService = r => require.ensure([], () => r(require('./special-service')), 'specialService')
// 快速提问
const quickQuestion = r => require.ensure([], () => r(require('./quick-question')), 'quickQuestion')
// IM咨询
const imChat = r => require.ensure([], () => r(require('./im/chat')), 'imChat')
// IM消息
const imMessage = r => require.ensure([], () => r(require('./im-message')), 'imMessage')
// 体检报告列表
const studioReportList = r => require.ensure([], () => r(require('./report-list')), 'studioReportList')
// 亲友列表
const peopleList = r => require.ensure([], () => r(require('./people-list')), 'peopleList')
// 新增亲友
const peopleEdit = r => require.ensure([], () => r(require('./people-edit')), 'peopleEdit')

export default {
  path: '/doctorStudio',
  component: studio,
  meta: { title: '医生工作室' },
  // redirect: '',
  children: [
    {
      path: 'list',
      name: 'studioList',
      component: studioList,
      meta: { title: '医生工作室' }
    },
    {
      path: 'detail',
      name: 'studioDetail',
      component: studioDetail,
      meta: { title: '医生工作室详情' }
    },
    {
      path: 'doctorHome',
      name: 'doctorHome',
      component: doctorHome,
      meta: { title: '医生主页' },
      children: [
        {
          path: 'specialService',
          name: 'specialService',
          component: specialService,
          meta: { title: '特色服务产品' }
        }
      ]
    },
    {
      path: 'quickQuestion',
      name: 'quickQuestion',
      component: quickQuestion,
      meta: { title: '快速提问' }
    },
    {
      path: 'imChat/:sessionId',
      name: 'imChat',
      component: imChat,
      meta: { title: '聊天咨询' }
    },
    {
      path: 'imMessage',
      name: 'imMessage',
      component: imMessage,
      meta: { title: '我的消息' }
    },
    {
      path: 'report',
      name: 'studioReportList',
      component: studioReportList,
      meta: { title: '选择体检报告' }
    },
    {
      path: 'people-list',
      name: 'peopleList',
      component: peopleList,
      meta: { title: '我的家人' }
    },
    {
      path: 'people-edit',
      name: 'peopleEdit',
      component: peopleEdit,
      meta: { title: '新增家人信息' }
    }
  ]
}


// WEBPACK FOOTER //
// ./src/views/doctorStudio/router.js